import { useState } from "react";
import { supabase } from '../utils/supabaseClient';

/**
 * Supabase Auth doesn't expose a client-side API to list a user's active
 * sessions (device/IP/last-active) — only signOut({ scope }) exists. So
 * this hook is intentionally limited to "sign out everywhere else",
 * not a sessions list. A future per-device list would need a Supabase
 * Edge Function using the service-role auth.admin.* API — not built here.
 */
export function useSecurity({ showSavedToast }) {
  const [signingOut, setSigningOut] = useState(false);
  const [signOutError, setSignOutError] = useState('');

  const signOutOthers = async () => {
    setSignOutError('');
    setSigningOut(true);
    try {
      const { error } = await supabase.auth.signOut({ scope: 'others' });
      if (error) throw error;
      showSavedToast?.();
    } catch (e) {
      setSignOutError(e?.message || 'Could not sign out other devices. Try again.');
    } finally {
      setSigningOut(false);
    }
  };

  return { signOutOthers, signingOut, signOutError };
}
